import { format, isValid } from "date-fns";

const isDateText = value => {
  if (typeof value !== "string") {
    return false;
  }

  const text = value.trim();

  if (!text || !isNaN(Number(text))) {
    return false;
  }

  return isValid(new Date(text));
};

const formatDateText = (value, mask = "dd.MM.yyyy") => {
  if (!isDateText(value)) {
    return value;
  }

  return format(new Date(value.trim()), mask);
};

export { formatDateText };
